"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SortType = void 0;
var SortType;
(function (SortType) {
    SortType["ASC"] = "asc";
    SortType["DESC"] = "desc";
})(SortType || (exports.SortType = SortType = {}));
